import {FieldArray} from 'react-final-form-arrays'
import {useTranslation} from 'react-i18next'

import BaseButton from '../../../../../../Components/Common/Buttons/BaseButton'
import SelectInput from '../../../../../../Components/Common/Inputs/SelectInput/SelectInput'
import Table from '../../../../../../Components/Common/Table'
import {useMeasurementsTable} from '../../../../hooks/useMeasurementsTable'

export const MeasurementsTable = () => {
  const {
    measurementsTableConfig,
    sizesList,
    widthsList,
    sizeSelectConfig,
    widthSelectConfig,
    handleAddLineClick,
    handleRemoveLineClick,
    currentSelectedCombinationFieldName,
    canRemoveMeasures
  } = useMeasurementsTable()

  const {t} = useTranslation()

  return (
    <>
      <div className="row my-3">
        <div className="col-md-6">
          <SelectInput
            label={t('SIZE')}
            options={sizesList}
            dataKey="sizeId"
            dataLabel="number"
            value={sizeSelectConfig.value}
            onChange={sizeSelectConfig.onchange}
          />
        </div>
        <div className="col-md-6">
          <SelectInput
            label={t('WIDTH')}
            options={widthsList}
            dataKey="productWidthId"
            dataLabel="productWidthTranslation"
            value={widthSelectConfig.value}
            onChange={widthSelectConfig.onchange}
          />
        </div>
      </div>
      <div className="mb-3">
        <FieldArray name={currentSelectedCombinationFieldName}>
          {({fields}) => {
            return (
              <Table
                tableColumns={measurementsTableConfig}
                tableInfo={fields?.value?.measuresArray}
                footer={false}
              />
            )
          }}
        </FieldArray>
      </div>
      <div className="row">
        <div className="col-md-6 col-sm-12">
          <div className="row g-2">
            <div className="col-12 col-sm-6 col-md-6">
              <BaseButton
                text={t('ADD_LINE')}
                onClick={handleAddLineClick}
                width="full"
              />
            </div>
            <div className="col-12 col-sm-6 col-md-6">
              <BaseButton
                text={t('REMOVE_LINE')}
                disabled={!canRemoveMeasures}
                onClick={handleRemoveLineClick}
                width="full"
              />
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
